module.exports = __webpack_public_path__ + "img/12.b195e98c.png";